<template>
  <div class="g-container" v-loading="loading">
    <h3 class="subtitle">智慧化综合业务管理平台</h3>

    <div class="page-login-wrap">
      <div class="page-login">
        <cmp-login-pic ref="myCmpLoginPic"></cmp-login-pic>

        <div class="content">
          <h1 class="title">Welcome</h1>
          <h3 class="subtitle1">用户登录</h3>

          <!-- 密码登录 -->
          <!-- <el-form @keyup.enter.native="submitForm('ruleForm')" :label-position="`top`" :model="ruleForm" :rules="rules" ref="ruleForm" class="form cus-form-top">
            <el-form-item prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入手机号">
                <i slot="prefix" style="display: flex;align-items: center;">
                  <img src="../../assets/images/icon_number.png" alt />
                </i>
              </el-input>
            </el-form-item>

            <el-form-item prop="pass">
              <el-input type="password" v-model="ruleForm.pass" placeholder="请输入密码">
                <i slot="prefix" style="display: flex;align-items: center;">
                  <img src="../../assets/images/icon_password.png" alt />
                </i>
              </el-input>
              <div class="el-form-item__error" v-if="passValid && errorMsg">{{errorMsg}}</div>
            </el-form-item>
          </el-form> -->

          <!-- 手机号验证码登录 -->
          <el-form @keyup.enter.native="submitForm('ruleForm')" :label-position="`top`" :model="ruleForm" :rules="rules" ref="ruleForm" class="form cus-form-top">
            <el-form-item prop="name">
              <el-input v-model="ruleForm.name" placeholder="请输入手机号">
                <i slot="prefix" style="display: flex;align-items: center;">
                  <img src="../../assets/images/icon_number.png" alt />
                </i>
              </el-input>
            </el-form-item>

            <el-form-item class="item_img_box" prop="verification">
              <el-input v-model="ruleForm.verification" placeholder="请输入图形验证码">
                <i slot="prefix" style="display: flex;align-items: center;">
                  <img src="../../assets/images/icon_password.png" alt />
                </i>
              </el-input>
              <img class="img_code" :src="codeUrl" alt="" @click="refresh">
            </el-form-item>

            <el-form-item class="vertify" prop="code">
              <el-input v-model="ruleForm.code" placeholder="请输入短信验证码" readonly @focus="handleFocusEvent">
                <i slot="prefix" style="display: flex;align-items: center;">
                  <img src="../../assets/images/icon_code.png" alt />
                </i>
              </el-input>
              <span class="m-btn" @click="sendMsg()" v-if="!resetMsg">发送验证码</span>
              <span class="m-btn diable" v-if="resetMsg">重新发送({{resetMsg}}s)</span>
            </el-form-item>
          </el-form>
          <div style="text-align: center">
            <el-button class="btn-sure" type="primary" @click="submitForm('ruleForm')">登录</el-button>
          </div>

          <!-- <div class="other-way">
            <div class="other-inner">
              <el-checkbox v-model="checked" v-if="ruleForm.name" @change="rememberPsw">记住账号</el-checkbox>
              <router-link tag="span" :to="{path: '/register?type=forget'}" class="m-btn">忘记密码</router-link>
              <router-link tag="span" :to="{path: '/register?type=add'}" class="m-btn fr">注册账户</router-link>
            </div>
          </div> -->
        </div>
      </div>

      <!-- <cmp-footer></cmp-footer> -->
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import { validate } from '@/utils/util'
import cmpLoginPic from './components/login-pic'
import cmpFooter from '@cmp/footer'
let myloding
export default {
  components: {
    cmpLoginPic,
    cmpFooter
  },
  data() {
    let validatePhoneNo = (rule, value, callback) => {
      if (!validate(value, 'phone')) {
        callback(new Error('手机号不存在'))
      } else {
        callback()
      }
    }
    let validatePass = (rule, value, callback) => {
      if (!validate(value, 'password')) {
        this.passValid = false
        callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
      } else {
        this.passValid = true
        callback()
      }
    }
    return {
      codeUrl: '/singleMuseum/Tools/getImgCode?t=' + Date.parse(new Date()),
      resetMsg: '', // 重新发送倒计时

      errorMsg: '', // 错误提示
      passValid: false, // 密码是否校验通过
      loading: false,
      checked: false,
      showFlag: false,
      ruleForm: {
        name: '',
        code: '',
        pass: '',
        verification: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' },
          // { validator: validatePass, trigger: 'blur' }
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          // { validator: validatePass, trigger: 'blur' }
        ],
        verification: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' },
        ]
      },
      codeLoading: false,
      loading: ''
    }
  },
  methods: {
    refresh() {
      this.codeUrl = '/singleMuseum/Tools/getImgCode?t=' + Date.parse(new Date())
    },
    startLoading(){  // 使用Element loading-start 方法
      myloding = Loading.service({
        lock: true,
        text: '正在发送……',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    stopLoading() {
      myloding.close()
    },
    // 获取验证码
    sendMsg() {
      if(this.codeLoading) return

      let valiNum = 0
      this.$refs.ruleForm.validateField(['name', 'verification'], (str, errorMsg) => {
        // console.log(str)
        // console.log(errorMsg)
        if (!errorMsg) {
          valiNum++
          console.log(valiNum)
          if(valiNum == 2) {
            this.codeLoading = true
            this.startLoading()
            // 发送验证码
            this.$http
              .post('/login/sendLoginCode', {
                phone: this.ruleForm.name,
                verification: this.ruleForm.verification
              })
              .then(res => {
                this.codeLoading = false
                this.stopLoading()
                if (!res.success) {
                  this.$message.error(res.message)
                } else {
                  this.timeDown()
                  this.$message.success('发送成功')
                }
              })
          }
        }
      })
    },
    // 倒计时
    timeDown() {
      this.resetMsg = 60
      let times = setInterval(() => {
        if (this.resetMsg <= 0) {
          this.resetMsg = ''
          clearInterval(times)
        } else {
          this.resetMsg--
        }
      }, 1000)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true

          this.$store
            .dispatch('LoginUser', {
              loginName: this.ruleForm.name,
              // password: this.ruleForm.pass
              verification: this.ruleForm.code
            })
            .then(() => {
              this.$store.dispatch('updataSiderbarCount')

              this.loading = false
              // 开发环境不循环 便于查看控制台
              // if (process.env.VUE_APP_START_INTERVAL === '1') {
              //   if (window.InitSetInterval) {
              //     clearInterval(window.InitSetInterval)
              //   }
              //   window.InitSetInterval = setInterval(() => {
              //     this.$store.dispatch('updataSiderbarCount')
              //   }, 3000)
              // }

              // this.getUserInfo()

              // this.$router.push({ path: '/project' })
            })
            .catch((msg) => {
              this.errorMsg = msg
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    rememberPsw(val) {
      if(!this.ruleForm.name){
        this.$message.warning('请输入账号')
        return
      }

      if(val){
        localStorage.setItem('lnsbName', this.ruleForm.name)
      }else{
        if(localStorage.hasOwnProperty('lnsbName')){
          localStorage.removeItem("lnsbName")
        }
      }

    },
    // 处理浏览器记住密码后 退出登录-》注册页面验证码被填充为手机号的bug
    handleFocusEvent(event) {
      event.target && event.target.removeAttribute('readonly')
    }
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // }
  },
  mounted(){
    this.showFlag = true
    this.ruleForm.name = localStorage.getItem('lnsbName') || ""
    this.checked = this.ruleForm.name.length > 0
  },
  // 添加这一行 可以保证组件不被keep-alive进行缓存
  deactivated() {
    this.$destroy()
  }
}
</script>

<style lang="scss" scoped>
.g-container {
  padding-top: 0;
  margin-top: 0;
  background: url(../../assets/images/pic_bg@2x.png) no-repeat center;
  background-size: 100% 100%;
  .subtitle {
    font-size: 28px;
    line-height: 28px;
    font-weight: bold;
    color: #fff;
    padding: 5px 0 0 40px;
  }

  .page-login-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .page-login {
    display: flex;
    justify-content: center;
    align-items: center;
    .content {
      // padding: 166px 54px 0;
      width: 497px;
      height: 561px;
      box-sizing: border-box;
      padding: 70px 0 130px;
      background: url(../../assets/images/board.png) no-repeat center;
      background-size: 100% 100%;
      // background-color: #fff;
      // box-shadow: 0px 10px 20px 0px rgba(181, 177, 221, 0.3);
      h1.title {
        text-align: center;
        font-size: 36px;
        line-height: 30px;
        font-weight: bold;
        color: $primary;
        margin-bottom: 11px;
      }

      .subtitle1 {
        text-align: center;
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: $primary;
        margin-bottom: 40px;
      }
      .btn-sure {
        border-radius: 20px !important;
        width: 320px;
        margin: 0 auto;
        &:hover {
          background: #33554e;
        }
        // &:focus{
        //   background: #33554e;
        // }
      }

      .other-way {
        line-height: 12px;
        margin-top: 15px;
        .el-checkbox {
          display: inline-block;
          width: 320px;
          margin: 0 auto;
        }
        .other-inner {
          width: 320px;
          margin: 0 auto;
          .el-checkbox {
            color: #018F78;
            display: inline-block;
            margin-bottom: 6px;
          }
        }
      }
      .form {
        /deep/ .el-form-item {
          box-sizing: border-box;
          color: $primary;
          margin: 0 auto 40px;
          width: 320px;
          height: 40px;
          border-radius: 20px;
          ::placeholder {
            position: relative;
            top: 2px;
            font-size: 16px;
            font-weight: 500;
            color: #426e65;
          }
          .el-input__inner {
            padding-left: 50px;
            background: #a7d5c1;
            border: 1px solid #306159;
            &:hover {
              border: 1.6px solid #306159;
            }
          }

          .el-input__prefix {
            left: 18px;
            i {
              height: 40px;
              line-height: 40px;
              img {
                width: 22px;
                height: 24px;
              }
            }
          }

          .el-form-item__error {
            font-weight: 600;
            color: $primary;
          }
        }

        .vertify {
          position: relative;
          .m-btn {
            position: absolute;
            right: 15px;
            top: 1px;
            line-height: 40px;
            &.diable {
              color: #666;
            }
          }
          /deep/ .el-input__inner {
            padding-right: 90px;
          }
        }

        .item_img_box {
          position: relative;
          .img_code {
            position: absolute;
            right: 15px;
            top: 5px;
            width: 100px;
            height: 30px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>


